import { styled, Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React from 'react';

type Props = {
    headline: string,
    copy?: string
}

const DetailContainer = styled.div`
    display: grid;
    grid-columns: 1 / 2;
    grid-template-columns: 1fr 1fr;
    align-content: baseline;

    @media screen and (min-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

const DetailLabel = styled.div``;

const DetailValue = styled.div``;

const Detail = (props: React.PropsWithChildren<Props>) => {

    return (
        <DetailContainer>
            <DetailLabel>
                <Text appearance={TokenTextAppearance.headline100} bold>{props.headline}</Text>
            </DetailLabel>

            {props.copy &&
                <DetailValue>
                    <Text appearance={TokenTextAppearance.copy200}>{props.copy}</Text>
                </DetailValue>
            }

            {
                props.children && <DetailValue>
                    {props.children}
                </DetailValue>
            }

        </DetailContainer>
    );
}

export default Detail;
